import React from 'react';
import { BarChart2 } from 'lucide-react';

export default function InformeViewer({ analisis }) {
  if (!analisis) return null;

  return (
    <div className="bg-blue-50 border border-blue-100 rounded-2xl p-5 mt-4">
      <h3 className="text-blue-800 font-bold flex items-center gap-2 mb-3">
        <BarChart2 className="w-5 h-5" /> Análisis del Documento
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Aquí puedes personalizar qué datos mostrar según lo que devuelva tu función analizarDatos */}
        <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
          <p className="text-xs text-gray-500 font-bold uppercase">Resumen General</p>
          <p className="text-sm text-gray-700 mt-1">
            {analisis.mensaje || "El archivo fue analizado correctamente."}
          </p>
        </div>
        
        {analisis.datosExtra && (
          <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
            <p className="text-xs text-gray-500 font-bold uppercase">Datos Extra</p>
            <pre className="text-xs text-gray-700 mt-1 overflow-auto max-h-32">
              {JSON.stringify(analisis.datosExtra, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}